import { v4 as uuid } from 'uuid'

const getCID = () => JSON.parse(localStorage.getItem('cid'))

const setCID = () => {
  if (!getCID()) { localStorage.setItem('cid', JSON.stringify(uuid())) }
}

export default {
  getCID,
  setCID,
  getToken: () => JSON.parse(localStorage.getItem('token')),
  setToken: token => localStorage.setItem('token', JSON.stringify(token))
}
